import { render } from "./AgentsIndex.vue?vue&type=template&id=6a3ba6e2"
import script from "./AgentsIndex.vue?vue&type=script&lang=js"
export * from "./AgentsIndex.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__